import React, { useState, useEffect } from 'react';
import { SectionLayout } from '@/components/section-layout';
import { TabsContent } from '@/components/ui/tabs';
import { Timer } from './components/Timer';
import { TimeEntriesTable } from './components/TimeEntriesTable';
import { TimeTrackingStats } from './components/TimeTrackingStats';
import { useLocation } from 'react-router-dom';
import { GenericTabBar } from '@/styles/GenericTabBar';
import { useVisibleTabs } from '@/hooks/useVisibleTabs';
import { NothingAvailable } from '@/components/NavigationUnavailable';
import type { NavKey } from '@/lib/navigation-catalog';

// which tabs a role gets is the navigation matrix (nav_visibility), one element per tab
const TAB_KEYS: Record<string, NavKey> = { Overview: 'project_management.time_tracking.tab.overview', Statistics: 'project_management.time_tracking.tab.statistics' };
const TABS = [{ value: 'Overview', label: 'Overview' }, { value: 'Statistics', label: 'Statistics' }];

export function TimeTrackingPage() {
  const visible = useVisibleTabs(TABS, TAB_KEYS);
  const [requestedTab, setActiveTab] = useState('Overview');
  const activeTab = visible.activeOf(requestedTab);
  const location = useLocation();

  // Check if we should open the form from navigation
  useEffect(() => {
    if (location.state?.openForm) {
      setActiveTab('Overview'); // Focus on overview where timer/form is
      // Clear the state to prevent reopening on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  if (activeTab === undefined) return <SectionLayout title="Time Tracking"><NothingAvailable message="No section of Time Tracking is available for your account." /></SectionLayout>;

  return (
    <SectionLayout title="Time Tracking">
      <GenericTabBar tabs={visible.tabs} activeTab={activeTab} onTabChange={setActiveTab} className="w-full">
        {visible.has('Overview') && (
        <TabsContent value="Overview" className="space-y-6 w-full">
          {/* The tracker itself lives in the app-level TimeTrackerProvider; this is only its face. */}
          <div className="flex justify-center">
            <Timer />
          </div>

          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Recent Entries</h3>
            <TimeEntriesTable />
          </div>
        </TabsContent>
        )}

        {visible.has('Statistics') && (
          <TabsContent value="Statistics" className="space-y-6 w-full">
            <TimeTrackingStats />
          </TabsContent>
        )}
      </GenericTabBar>
    </SectionLayout>
  );
}
